import { MoreOptionsVerticalIcon as h, ListIcon as f, ImageIcon as m, DownloadIcon as H, ArticleIcon as y, ChartBarIcon as g, ShareIcon as I, QuoteIcon as L } from "@frontiers/brink-icons";
import { openBlock as p, createElementBlock as C, createElementVNode as w } from "vue";
import { _ as V } from "./_plugin-vue_export-helper.dad06003.js";
const b = {}, M = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T = /* @__PURE__ */ w("path", { d: "M18.4791 18.1871H17.0924V16.9353H18.4727V15.3945H19.9749V19.9397H16.9062V18.6622H18.4791V18.1871ZM13.6577 19.9397H12.0336L10.2617 15.3945H11.9244L12.1619 16.0622H13.6064L13.8311 15.3945H15.4488L13.6577 19.9397ZM12.8681 18.354L13.2405 17.2306H12.5022L12.8681 18.354ZM8.2634 19.9397H6.72266V15.3945H8.2634V19.9397ZM4.21213 19.9397H2.25413C2.03158 19.9397 1.81031 19.917 1.5899 19.8721C1.3695 19.8271 1.17262 19.7479 0.99929 19.6345C0.82596 19.5211 0.68601 19.3692 0.57859 19.1787C0.47159 18.9883 0.4181 18.7495 0.4181 18.4631C0.4181 18.1768 0.48657 17.9397 0.6231 17.7283C0.75962 17.5165 0.95607 17.3525 1.212 17.237L0.0585899 15.3945H1.81374L2.68425 17.0187H2.72919V15.3945H4.21213V19.9397ZM2.74203 18.0202H2.44244C2.39151 18.0202 2.33502 18.0245 2.27382 18.033C2.21219 18.0416 2.15484 18.0596 2.10177 18.0874C2.0487 18.1152 2.00419 18.1537 1.96781 18.2029C1.93186 18.2521 1.91346 18.3172 1.91346 18.3989C1.91346 18.4807 1.92844 18.5445 1.95797 18.5915C1.9875 18.6386 2.02602 18.6737 2.07267 18.6972C2.11932 18.7208 2.17024 18.7358 2.22545 18.7422C2.28066 18.7486 2.33159 18.752 2.37824 18.752H2.74117L2.74203 18.0202ZM1.49969 1.81508H2.88635V3.06692H1.50611V4.60764H0.00391006V0.0625H3.07252V1.34002H1.49969V1.81508ZM6.32234 0.0625H7.94653L9.7184 4.60764H8.0557L7.81813 3.93999H6.3737L6.14901 4.60764H4.53125L6.32234 0.0625ZM7.11197 1.64816L6.73962 2.77161H7.47789L7.11197 1.64816ZM11.7109 0.0625H13.2517V4.60764H11.7109V0.0625ZM15.7656 0.0625H17.7236C17.9462 0.0625 18.1674 0.08518 18.3879 0.13012C18.6083 0.17506 18.8051 0.25423 18.9785 0.36765C19.1518 0.48106 19.2917 0.633 19.3992 0.82345C19.5062 1.0139 19.5597 1.25271 19.5597 1.53903C19.5597 1.82535 19.4912 2.06245 19.3547 2.2743C19.2181 2.48615 19.0217 2.64964 18.7658 2.76562L19.9192 4.60807H18.164L17.2935 2.98389H17.2486V4.60807H15.7656V0.0625ZM17.2357 1.98199H17.5353C17.5863 1.98199 17.6427 1.97771 17.7039 1.96915C17.7656 1.96059 17.8229 1.94261 17.876 1.9148C17.9291 1.88698 17.9736 1.84846 18.0099 1.79924C18.0459 1.75002 18.0643 1.68497 18.0643 1.60323C18.0643 1.52148 18.0493 1.45771 18.0198 1.41064C17.9903 1.36356 17.9517 1.32846 17.9051 1.30492C17.8584 1.28139 17.8075 1.26641 17.7523 1.25999C17.6971 1.25357 17.6462 1.25014 17.5995 1.25014H17.2366L17.2357 1.98199ZM4.54514 7.31453V8.9387L0 10.7105V9.0478L0.66765 8.8103V7.36589L0 7.1412V5.52344L4.54514 7.31453ZM2.95948 8.1042L1.83603 7.73181V8.4701L2.95948 8.1042ZM4.54514 12.1445V13.6853H0V12.1445H4.54514ZM15.457 12.5171V10.8929L20.0022 9.1211V10.7838L19.3345 11.0213V12.4658L20.0022 12.6904V14.3082L15.457 12.5171ZM17.0427 11.7275L18.1661 12.0998V11.3616L17.0427 11.7275ZM15.457 7.68135V6.14062H20.0022V7.68135H15.457Z" }, null, -1), v = [
  T
];
function k(t, e) {
  return p(), C("svg", M, v);
}
const S = /* @__PURE__ */ V(b, [["render", k]]), A = 300, _ = [
  "outline",
  "figures",
  "cite",
  "metrics",
  "share",
  "supplementaryMaterial",
  "fair2DataPortal"
], N = (t) => {
  const e = [];
  return t.hasOutline && e.push({
    targetId: "outline",
    titleToolbar: "Outline",
    icon: "ListIcon",
    title: "Outline",
    isHiddenMobile: !1
  }), t.hasFigures && e.push({
    targetId: "figures",
    titleToolbar: "Figures",
    icon: "ImageIcon",
    title: "Figures",
    isHiddenMobile: !1
  }), t.hasCite && e.push({
    targetId: "cite",
    titleToolbar: "Cite",
    icon: "QuoteIcon",
    title: "Cite article",
    isHiddenMobile: !1
  }), t.hasShare && e.push({
    targetId: "share",
    titleToolbar: "Share",
    icon: "ShareIcon",
    title: "Share article",
    isHiddenMobile: !1
  }), t.hasMetrics && e.push({
    targetId: "metrics",
    titleToolbar: "Metrics",
    icon: "ChartBarIcon",
    title: "Article metrics",
    isHiddenMobile: !1
  }), t.hasSupplementaryMaterial && e.push({
    targetId: "supplementaryMaterial",
    titleToolbar: "Suppl. material",
    icon: "ArticleIcon",
    title: "Supplementary material",
    isHiddenMobile: !1
  }), t.fair2DataPortalURL && e.push({
    targetId: "fair2DataPortal",
    titleToolbar: `FAIR²
Data Portal`,
    icon: "Fair2DataPortalIcon",
    title: "FAIR² Data Portal",
    isHiddenMobile: !1,
    isExternalLink: !0,
    href: t.fair2DataPortalURL,
    target: "_blank",
    rel: "noopener noreferrer"
  }), e;
}, Q = (t) => {
  switch (t) {
    case "QuoteIcon":
      return L;
    case "ShareIcon":
      return I;
    case "ChartBarIcon":
      return g;
    case "ArticleIcon":
      return y;
    case "DownloadIcon":
      return H;
    case "ImageIcon":
      return m;
    case "ListIcon":
      return f;
    case "MoreOptionsVerticalIcon":
      return h;
    case "Fair2DataPortalIcon":
      return S;
  }
}, Y = (t, e) => t.find(
  (o) => o.targetId === e
), W = (t) => {
  let e = !1;
  return _.forEach((o) => {
    t === `#${o}` && (e = !0);
  }), e;
}, d = () => A, $ = () => d() * 1e-3, D = "data-scroll-top";
let r, l, a;
const n = 400, i = [];
let s = null;
const Z = (t) => {
  for (let e = i.length; e >= 0; e--)
    if (i[e] === t) {
      i.splice(e, 1);
      break;
    }
}, B = () => {
  const t = document.documentElement.scrollHeight, e = window.innerHeight;
  return t > e;
}, E = (t) => {
  if (typeof t.value != "boolean")
    throw new Error(
      "The binding of lock-scroll directive must be a boolean value."
    );
}, P = () => {
  if (r.getAttribute("lock-scroll") === "true")
    return;
  const e = B();
  if (window.scrollY) {
    const o = window.pageYOffset;
    a.style.top = `${-o}px`, l.setAttribute("data-scroll-top", o.toString());
  } else
    l.setAttribute("data-scroll-top", "");
  a.style.display = "block", l.style.height = "100%", l.style.width = "100%", l.style.overflow = "hidden", l.style.position = "fixed", r.style.height = "100%", r.style.overflowY = e ? "scroll" : "hidden", r.style.overflowX = "hidden";
}, F = () => {
  const t = l.getAttribute(D);
  l.style.height = "", l.style.width = "", l.style.overflow = "", l.style.position = "", l.style.paddingRight = "", r.style.height = "", r.style.overflow = "", a.style.top = "", a.style.display = "", t && (window.scrollTo(0, parseInt(t, 10)), window.setTimeout(() => {
    l.setAttribute("data-scroll-top", "");
  }, 0));
}, R = () => {
  const t = document.querySelectorAll(
    "body > *:not(script):not(noscript)"
  ), e = [];
  if (t.length === 0)
    throw new Error(
      "[directive:lock-scroll] no children of body have been found"
    );
  for (let o = 0; o < t.length; o++)
    getComputedStyle(t[o]).position === "relative" && e.push(t[o]);
  if (e.length === 0)
    throw new Error(
      "[directive:lock-scroll] no valid children of body with relative position have been found"
    );
  return e.length > 1 && console.warn(
    "[directive:lock-scroll] serveral elements with position relative have been found. The directive will use the first one to lock the scroll."
  ), e[0];
}, c = (t, e) => {
  if (u(), e.value === !0) {
    if (clearTimeout(s), i.push(t), i.length === 1) {
      const o = e.modifiers.initialDelay === !0 ? n : e.modifiers.initialMiddleDelay ? n * 0.5 : 0;
      s = setTimeout(function() {
        P(), r.setAttribute("lock-scroll", "true");
      }, o);
    }
  } else if (Z(t), i.length === 0) {
    const o = e.modifiers.noDelay === !0 ? 0 : e.modifiers.backMiddleDelay ? n * 0.5 : e.modifiers.backDelayInfoDrawer ? d() : n;
    s = setTimeout(function() {
      F(), r.setAttribute("lock-scroll", "false");
    }, o);
  }
}, u = () => {
  a || (r = document.getElementsByTagName("html")[0], l = document.getElementsByTagName("body")[0], a = R());
}, q = {
  mounted(t, e) {
    E(e), u(), e.value === !0 && c(t, e);
  },
  updated(t, e) {
    e.oldValue !== e.value && c(t, e);
  },
  unmounted(t) {
    c(t, { value: !1, modifiers: {} });
  }
};
export {
  q as B,
  S as F,
  Y as a,
  Q as b,
  $ as c,
  N as d,
  d as g,
  W as v
};
